/**
 * 权限组一览页面
 * 创建时间：2017-03-23
 * 创建人：baixx
 * 修改时间：2017-3-31 
 */
<template>
	<div id="auth-list" class="wrapper wrapper-content fadeInRight tabBox">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<!--表单查询开始-->
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">权限组名称</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParams.roleName" maxlength="30">
					</div>
					<label class="col-sm-1  control-label">状态</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParams.isEnable">
							<option v-for="status in enableList" :value="status.value">{{status.name}}</option>
						</select>
					</div>		 
				</div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button v-if="permission.indexOf('authorityList_select') == -1" class="btn btn-primary" @click="searchInfo">查询</button>
						<button v-if="permission.indexOf('authorityList_reset') == -1" class="btn btn-primary" @click="reset">重置</button>
					</div>
			    </div>
				<div class="hr-line-dashed"></div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button v-if="permission.indexOf('authorityList_add') == -1" v-show="this.isAdmin>0" class="btn btn-primary" @click="open(1)">新建权限组</button>
					</div>
				</div>
			</div>
			<!--表单查询结束-->
			<!--表格开始-->
			<div class="table-responsive ">
				<div style="overflow: auto;">
					<table class="table table-striped table-bordered fixedTable module_table" style="min-width: 1600px;">
						<thead>
							<tr>
								<th width="5%" @click="reorder('order')">序号<i></i></th>
								<th>权限组名称</th>
								<th class="hand" @click="reorder('status')">状态<i class="icon_sort" :class="[statusClicked?'sort_top':'sort_bottom']"></i></th>
								<th class="hand" @click="reorder('enterprise')">所属企业<i class="icon_sort" :class="[enterpriseClicked?'sort_top':'sort_bottom']"></i></th>
								<th width="15%">授予用户清单</th>
								<th>已授权功能数</th>
								<th width="30%">已授权分支</th>
								<th>备注</th>
								<th></th>
							</tr>
						</thead>		
						<tbody>
							<tr v-for="(fileInfo,index) in orgList" v-bind:key="index">
								<td>{{index+1}}</td>
								<td>{{fileInfo.roleName}}</td>
								<td>{{fileInfo.isEnableName}}</td>
								<td>{{fileInfo.customerName}}</td>
								<td class="list" style="width:15%;">{{fileInfo.userList}}</td>
								<td>{{fileInfo.resourceCount}}</td>
								<td class="list" style="width:30%;">{{fileInfo.groupAll === 1 ? '所有分支' : fileInfo.groupList}}</td>
								<td>{{fileInfo.remark}}</td>
								<td class="text-center">
									<a v-if="permission.indexOf('authorityList_detail') == -1" class="text-left" @click="detail(index)">详情&nbsp;</a>
									<a v-if="permission.indexOf('authorityList_edit') == -1" v-show="isAdmin==9||(isAdmin==1 && customerId==fileInfo.customerId)" class="text-right" @click="edit(index)">&nbsp;编辑&nbsp;</a>
									<a v-if="permission.indexOf('authorityList_delete') == -1" v-show="isAdmin==9 ||(isAdmin!=0 && customerId==fileInfo.customerId)"  @click="removeConform(index)">&nbsp;删除</a>
									<i v-show="isAdmin==0 ||(isAdmin==1 && customerId!=fileInfo.customerId)" title="不可操作">&nbsp;删除</i>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<!--分页组件开始-->
			<pagination v-if="orgList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
			<!--分页组件结束-->
			<sub-page :show="showSubPage" 
				:bigTitleMsg="title" 
				v-on:cancel="closeSubPage" 
				:scroll="scrollTop">
				
				<div slot="bodycontent">
					<page-authority-edit
						:mode="mode"
						v-on:callback="handleCallback"
						:data="currentOrg"
						:isShow="showSubPage">
					</page-authority-edit>
				</div>
			</sub-page>
		</div>
		<!--   弹出框子组件        -->
		<tab-modal ref="modal1" size="small" title="提示" :scroll='scrollTop' v-on:beforeReveal="adjustPois" v-on:cancel="closeModal('modal1')">
			{{messageStr}}
			<div slot="footer">
		            <!--<button class="btn btn-primary">Say Hi</button>-->
		            <button @click="closeModal('modal1')" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<!--   弹出框子组件2        -->
		<tab-modal ref="modal2" size="small" title="提示" :scroll='scrollTop' v-on:beforeReveal="adjustPois" v-on:cancel="closeModal('modal2')">
			确定删除 {{orgList[listIndex]?orgList[listIndex].roleName:''}} 权限组？
			<div slot="footer">
		            <button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
		            <button @click="removeItem()" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>
<script>
	import SubPage from 'components/common/SubPage'
	import Pagination from 'components/common/Pagination'
	import PageAuthorityEdit from 'components/pages/authority/PageAuthorityEdit'
	import TabModal from 'components/common/TabModal'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import {INFO_STATUS_ALL} from 'static/constant'
	import classlist from 'util/classlist'
	export default {
		name: "PageAuthorityList",
		components: {
			Pagination,
			SubPage,
			PageAuthorityEdit,
			TabModal
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["authorityList"]?this.$store.state.permission.permission["authorityList"]:[],
				loadingstatus:false,
				enableList: INFO_STATUS_ALL,
				isAdmin:0,
				customerId:0,
				showSubPage: false,
				enterpriseClicked: false, 	//是否点击了顺序号排序按钮，默认没点击
				statusClicked: false,		//是否点击了状态排序按钮，默认没点击
				orderClicked: false,		//是否点击了状态排序按钮，默认没点击
				title:'',					//子组件标题
				pageInfo:{
					pages: 1,
					total: 10,
					pageNum: 1
				},	  			//分页所需信息
				pageNo:0,		  			//分页返回的当前页数
				orgList: [], 				//表格数据列表
				scrollTop: '0',
				mode: 1,					//"1"：新建模式		“2”：编辑模式		“3”：查看模式 （不可编辑）
				listIndex: 0,				//列表索引
				queryParams: {				//查询参数
					roleName: "",
					isEnable: "clear",
					page_index: 1,			//页码
					sort_desc: "",			//正续参数  "g.PATH,g.ORDER_NO"(顺序号排序) c.CUSTOMER_NAME(所属企业排序)
					sort_asc: ""			//倒序参数
				},
				messageStr: "",				// 弹出框提醒内容
				currentOrg: {}
			};
		},
		beforeMount() {
			this.getTableInfo();
		},
		created(){
			this.isAdmin = this.$store.state.user.admin;
			this.customerId = this.$store.state.user.groupid;
		},
		watch: {
			showSubPage(val){
				if(val === true){
					classlist.toggleScroll('close','#auth-list',this);
				}else{
					classlist.toggleScroll('open','#auth-list',this);
				}
			}
		},
		methods: {
			adjustPois(){
				classlist.toggleScroll('close','#auth-list',this);
			},
			getTableInfo() {
				this.loadingstatus = true;
				var params = this.deepcopy(this.queryParams);
				if(params.isEnable == 'clear') 
					params.isEnable = '';
				// 删除不用属性
//				if(!params.isEnable) delete params.isEnable;
//				if(!params.roleName) delete params.roleName;
				this.$http.get(process.env.API_ROOT + '/account/roles', {params})
					.then((res) => {
						if(res.data.success) {
							var list = res.data.data.list;
							list.forEach( item => {
								if(item.isEnable == '1'){
									item.isEnableName = '启用';
								} else {
									item.isEnableName = '禁用';
								}
								return item;
							})
							this.orgList = [];
							this.orgList = list;
							this.pageInfo.pages = res.data.data.pages;
							this.pageInfo.total = res.data.data.total;
//							if(list.length == 0){
//								this.openModal1("查询条件不存在");
//							}
						} else {
							this.openModal1(res.data.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.openModal1(res.data.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModal1(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					});
			},
			reorder(key) { //点击表格排序
				
				// 以所属企业排序
				if (key === 'enterprise'){
					this.enterpriseClicked = !this.enterpriseClicked;
					if(!this.queryParams.sort_desc){
						this.queryParams.sort_desc = "customername";
						this.queryParams.sort_asc = "";
					} else {
						this.queryParams.sort_desc = "";
						this.queryParams.sort_asc = "customername";
					}
				// 以状态排序
				} else {
					this.statusClicked = !this.statusClicked;
					if(!this.queryParams.sort_desc){
						this.queryParams.sort_desc = "isenable";
						this.queryParams.sort_asc = "";
					} else {
						this.queryParams.sort_desc = "";
						this.queryParams.sort_asc = "isenable";
					}
				}
				//把点击的排序方式传给后台，由后台排序，再返回给前台
				this.getTableInfo();
			},
			getPageNo(pageNo) { //从分页组件获取页码参数
				//把分页参数传给后台，由后台返回新页码数据，再刷新页面
				this.queryParams.page_index = pageNo;
				this.getTableInfo();
			},
			removeItem() { //点击删除表格信息
				this.loadingstatus = true;
				this.closeModal('modal2');
				//把index传给后台，由后台删除（再前台删除）
				this.$http.delete(process.env.API_ROOT + "/account/roles/" + this.orgList[this.listIndex].id)
				.then( res => {
					if(res.data.success){
						this.openModal1(OPERATE_SUCCESS);
						this.getTableInfo();
					} else {
						this.openModal1(res.data.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.openModal1(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				});
			},
			removeConform(index){
				this.listIndex = index;
				this.openModal("modal2");
			},
			//查询方法
			searchInfo(){
				this.queryParams.page_index = 1;
				this.getTableInfo();
			},
			// 点击重置
			reset() {
				this.queryParams = {		//查询参数
					roleName: "",
					isEnable: "",
					page_index: 1,			//页码
					sort_desc: "",			//正续参数  "g.PATH,g.ORDER_NO"(顺序号排序) c.CUSTOMER_NAME(所属企业排序)
					sort_asc: ""			//倒序参数
				}
			},
			// 点击详情
			detail(index){
				this.listIndex = index;
				this.currentOrg = this.orgList[index];
				this.open(3);
			},
			// 点击编辑
			edit(index){
				this.listIndex = index;
				this.currentOrg = this.orgList[index];
				this.open(2);
			},
			open(mode){
				switch (mode){
					case 1: 
						this.title = "新建权限组";
						break;
					case 2: 
						this.title = "编辑权限组";
						break;
					case 3: 
						this.title = "查看权限组";
						break;
				}
				this.mode = mode;
				this.showSubPage = true;
			},
			closeSubPage(){
				this.showSubPage = false;
			},
			// 处理子组件回调
			handleCallback(mark){
				if(mark === "edit-success" || mark === "new-success"){
					this.showSubPage = false;
					this.getTableInfo();
				}
			},
			// 深复制
			deepcopy(source) { 
				var result={};
				for (var key in source) {
			      result[key] = typeof source[key]==='object'? this.deepcopy(source[key]): source[key];
				} 
			   	return result; 
			},
			// 消息弹出框相关 ==============================
			openModal(ref) {
            	this.$refs[ref].open();
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#auth-list',this);
        	},
        	openModal1(message){
        		this.messageStr = message;
        		this.openModal("modal1")
        	}
		}
	}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// PageAuthorityList.vue?c1b141de